import { push, goBack } from 'react-router-redux'
import {ApiHelper } from '../../utils/ApiHelper'
import { submit, SubmissionError } from 'redux-form'
import moment from 'moment'


export function listVehicles() {
  return dispatch => {
    dispatch({type: 'VEHICLES_REQUESTED'})
    return ApiHelper.listVehicles()
      .then(response => {

        dispatch({
          type: 'VEHICLES_SUCCESS',
          user: {
            vehicles: response.data
          }
        })

        return response
      })
  }
}

export function createVehicle(data) {
  var vehicle = { ...data}

  if (data.odometer_readings) {
    var odometer_readings = {}
    for (const [index, value] of data.odometer_readings.entries()) {
      odometer_readings[moment().format('YYYY') - index] = value
    }
    vehicle.odometer_readings = odometer_readings
  }


  return (dispatch, getState) => {

    dispatch({type: 'CREATE_VEHICLE_REQUEST'})

    return ApiHelper
      .createVehicle(vehicle)
      .then(response => {
        // Catch error
        if (response.status != 201 ) {
          throw new SubmissionError({
            '': 'Vehicle not saved.',
            _error: 'Vehicle update failed!'
          })
          dispatch({type: 'CREATE_VEHICLE_ERROR'})
        } else {
          dispatch({type: 'CREATE_VEHICLE_SUCCESS', vehicle: response.data})
          dispatch(push(`/account/vehicles`))
        }
        return response
      })
  }
}
export function updateVehicle(data) {

  var odometer_readings = {}
  for (const [index, value] of data.odometer_readings.entries()) {
    odometer_readings[moment().format('YYYY') - index] = value
  }

  var vehicle = { ...data, odometer_readings: odometer_readings }

  return (dispatch, getState) => {

    dispatch({type: 'UPDATE_VEHICLE_REQUEST'})

    return ApiHelper
      .updateVehicle(vehicle)
      .then(response => {

        if (response.status != 200) {
          throw new SubmissionError({
            '': 'Vehicle not updated.',
            _error: 'Vehicle update failed!'
          })
        } else {
          dispatch({type: 'UPDATE_VEHICLE_SUCCESS', vehicle: response.data})
        }

        return response
      })
  }
}


export function deleteVehicle(token_id) {
  return (dispatch, getState) => {
    dispatch({type: 'DELETE_VEHICLE', token_id: token_id})
    const { vehicles } = getState().account //gets new state AFTER REMOVE_VEHICLE fires
    return ApiHelper
      .deleteVehicle(token_id)
      .then(response => {
        console.log(response);
        console.log(response.status);
        if (response.status != 204 && response.status != 200) {
          throw new SubmissionError({
            '': 'Vehicle not updated.',
            _error: 'Vehicle update failed!'
          })
        } else {
          dispatch({type: 'DELETE_VEHICLE_SUCCESS', token_id: token_id})
          dispatch(push(`/account/vehicles`))
        }
        return response
      })
  }
}



// WEBPACK FOOTER //
// ./src/account/vehicles/actions.js